import container from "@/lib/di/container";
import { useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { DetailModal } from "./modals/DetailModal";
import { Button, Dropdown, message, Tooltip } from "antd";
import { AppstoreAddOutlined, InfoCircleOutlined, MoreOutlined } from "@ant-design/icons";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { WaterSupplySuspensionModel, WaterSupplySuspensionModelFactory } from "@/core/models/water-supply-suspension.model";
import { WaterSupplySuspensionRepo } from "@/core/repos/tables/water-supply-suspension.repo";
import { suspensionStatusPipe } from "@/core/pipes/suspension-status.pipe";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import { usePermissionStore } from "@/core/stores/permission.store";
import { DeleteButton } from "../../components/table/DeleteButton";
import { useLocation, useNavigate } from "react-router";

const waterSupplySuspensionRepo = container.get(WaterSupplySuspensionRepo);

export default function WaterSupplySuspensionPage() {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const titleData = useTitleDataStore();
    const permissionStore = usePermissionStore();
    const [modalData, setModalData] = useState<WaterSupplySuspensionModel>(WaterSupplySuspensionModelFactory.getEmpty())
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map())
    const [selectedRows, setSelectedRows] = useState<WaterSupplySuspensionModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [filterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
    ])

    const showDetail = (record: WaterSupplySuspensionModel) => {
        setModalData(record);
        setDetailModal(true);
    };

    const showLevels = (record: WaterSupplySuspensionModel) => {
        navigate(encodeURI(`${pathname}/level?id=${record.id}`))
    };


    const init = async () => {
        titleData.setTitleActions({
            text: "Tạo lịch ngưng cấp nước",
            onPress: () => {
                showDetail(WaterSupplySuspensionModelFactory.getEmpty())
            }
        })
    }

    useEffect(()=>{init()}, []);

    const deleteSelected = async () => {
        setDeleting(true);
        const result = await waterSupplySuspensionRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }



    async function onFilterChange(map: Map<string, FilterSearchPayload>) {
        setFilterMap(new Map(map));
    }

    function onRowSelect(rows: WaterSupplySuspensionModel[]) {
        setSelectedRows([...rows]);
    }

    return (
    <div className="px-4 py-6">
        {contextHolder}
        <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
            <div key={1} className="mt-6">
                <DeleteButton loading={deleting} length={selectedRows.length} onConfirm={deleteSelected}/>
            </div>
        ]}/>
        <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
            <DataTable<WaterSupplySuspensionModel>
                columns={[
                    { dataIndex: 'name', name: 'Tên' },
                    { dataIndex: 'reason', name: 'Lý do ngưng cấp nước' },
                    { dataIndex: 'status', name: 'Trạng thái', pipe: suspensionStatusPipe},
                    { dataIndex: 'createdAt', name: 'Ngày tạo', pipe: formatDateTimePipe },
                    { dataIndex: 'createdBy', name: 'Người tạo' },
                    {
                        name: 'Thao tác',
                        render: (_, record) => (
                            <div className="flex flex-row px-1 items-center justify-center">
                                <Tooltip className="mr-1" title="Sửa"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)}/></Tooltip>
                                <Dropdown menu={{items: [
                                    {
                                        key: '1',
                                        label: <p>Xem Vùng tạm ngưng cấp nước</p>,
                                        icon: <AppstoreAddOutlined />,
                                        onClick: () => showLevels(record)
                                    },
                                ]}} trigger={["hover"]}>
                                    <Button type="text" icon={<MoreOutlined />}/>
                                </Dropdown>
                            </div>
                        ),
                        fixed: "right",
                        width: 50
                    },
                ]}
                repository={waterSupplySuspensionRepo}
                filterMap={filterMap}
                onSelect={onRowSelect}
            ></DataTable>
        </div>
        <DetailModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData}></DetailModal>
    </div>)
}